import httpExternal from "../http-external";

class ExternalDataService {
  
  // Upload file to external server
  uploadFile(data, header) {
    return httpExternal.post("spa/updfile", data, header);
  }
  //upload to presigned url
  getSignedUrl(data, header) {
    return httpExternal.post("spa/get-presigned-url", data, header);
  }
}

export default new ExternalDataService();

